import { getCurrentUser } from '../../../services/helper';
import { LessonPlan, Recipe } from '../../../types/lessonPlan.type';
import { getLessonPlanEquipmentNames } from '../../../utils/utils';

interface RecipeEquipmentProps {
  recipe: Recipe;
  lessonPlan?: LessonPlan | null;
}

const RecipeEquipment: React.FC<RecipeEquipmentProps> = ({ recipe, lessonPlan }) => {
  const currentUser = getCurrentUser();
  const forInstructor = !!currentUser?.hasDashAccess;
  const equipments = lessonPlan
    ? getLessonPlanEquipmentNames(lessonPlan.recipes, forInstructor)
    : getLessonPlanEquipmentNames([recipe], forInstructor);

  if (!equipments.length) return null;

  return (
    <>
      <div>
        <h3 className="text-info fw-bolder mb-3">Equipment Checklist</h3>
        <div>
          <ul
            role="list"
            className="w-list-unstyled"
          >
            {equipments.map((equipment, index) => (
              <li
                className="equipment-item"
                key={`equipment-${index}`}
              >
                {equipment}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="dots recipe"></div>
    </>
  );
};

export default RecipeEquipment;
